import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

export class Page {
  constructor(
      public id: string,
      public name: string,
      public children?: Page[],
      public externalUrl?: string,
  ) {}
}

const PAGES = [
    new Page('home', 'Home'),
    new Page('clients', 'Clients'),
    new Page('jobs', 'Jobs'),
    new Page('actions', 'Actions'),
    new Page('finance', 'Finance'),
    new Page('report', 'Reports', [
        new Page('allocated', 'Monthly Margin'),
        new Page('timevalue', 'Time Value'),
        new Page('billable', 'Billable Hours'),
        new Page('actionsnapshots', 'Action Snapshot'),
    ]),
    new Page('calendar', 'Calendar'),
    new Page('timesheets', 'Timesheets', [
        new Page('timer', 'Timer'),
        new Page('reports', 'Reports'),
    ]),
];


@Injectable()
export class NavService {
    getPages() {
        return of(PAGES);
    }

    getPage() {
        return this.getPages();
        // (+) before `id` turns the string into a number
    }
}
